import useStringQueryParamState from "lib/queryParamState/useStringQueryParamState";
import { resetPagination } from "gui/browse-shared/usePaginationState";

const tabNames = ["dashboards", "queries", "library"] as const;
export type TabName = typeof tabNames[number];

const defaultTab = "library";

export function useActiveTab() {
  const [
    activeTab,
    setActiveTab,
    getTabUrl,
  ] = useStringQueryParamState<TabName>("tab", defaultTab, {
    onChangeTransform: resetPagination,
  });

  return {
    getTabUrl,
    setActiveTab,
    activeTab: isTabName(activeTab) ? activeTab : defaultTab,
  };
}

function isTabName(activeTab: string): activeTab is TabName {
  // @ts-ignore: array.includes(x) is ok even though x might not be in array
  return tabNames.includes(activeTab);
}
